const e=e=>{let o="";return Object.keys(e).forEach((t=>{o+=`${t}=${encodeURIComponent(e[t])}&`})),o.slice(0,-1)};export{e as serializeParams};
//# sourceMappingURL=serializeParams.js.map
